<template>
    <div class="world-section">
        <div class="d-flex align-center justify-space-between py-12 mt-12 mx-auto">
            <div class="mx-auto px-2">
              <div class="d-flex flex-column flex-md-row py-12 mb-6 justift-space-betweem">
                <div class="d-flex justify-space-between mb-6" style="flex: 1 1 100%">
                  <v-img src="@/assets/media-types/news.svg" height="40" contain></v-img>
                  <v-img src="@/assets/media-types/magazine.svg" height="40" contain></v-img>
                  <v-img src="@/assets/media-types/online.svg" height="40" contain></v-img>
                  <v-img src="@/assets/media-types/radio 2.svg" height="40" contain></v-img>
                </div>
                <div class="d-flex justify-space-between mb-6" style="flex: 1 1 100%">
                  <v-img src="@/assets/media-types/billboard.svg" height="40" contain></v-img>
                  <v-img src="@/assets/media-types/cinema.svg" height="40" contain></v-img>
                  <v-img src="@/assets/media-types/tv.svg" height="40" contain></v-img>
                  <v-img src="@/assets/media-types/metro.svg" height="40" contain></v-img>
                </div>
              </div>
              <div class="text-h3 text-center font-weight-bold py-3" v-html="$t('home.world.title')"></div>
              <div class="text-h5 text-center py-3 primary--text" v-html="$t('home.world.subtitle')"></div>
              <div class="text-h3 text-center font-weight-bold pt-12 pb-3" v-html="$t('home.world.title_2')"></div>
              <div class="text-h5 text-center primary--text py-3" v-html="$t('home.world.subtitle_2')"></div>
              <div class="d-flex justify-center pt-6 pb-3">
                <v-btn color="primary" x-large class="mx-auto" elevation="0" to="/cadastrar">{{ $t('home.world.cta') }}<v-icon small class="ml-12">mdi-arrow-right</v-icon></v-btn>
              </div>
            </div>
            
          </div>
    </div>
</template>
<script>
export default {
    name: "WorldSection"
}
</script>
<style>
.world-section{
  background: url("https://lion-web-site.s3.amazonaws.com/public/world-dot-map.svg") no-repeat;
  background-size: contain;
  background-position: center;
}
</style>